import React from 'react';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
// Models
import mDeviceLog from 'models/deviceLog';
// Custom
import { deviceLogDataShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';

const LogInfo = ({ log }) => {
  // Log information
  const type = mDeviceLog.type(log);
  const tag = mDeviceLog.tag(log);
  const level = mDeviceLog.level(log);
  const origin = mDeviceLog.origin(log);

  return (
    <div className="pt-2">
      <div className="row">
        <div className="col-12 d-flex flex-nowrap align-items-center">
          <AppIcon defaultColor id="itemHour" className="mr-2" />
          <LocalizedStandardDate value={log.date} />
        </div>
        <div className="col-12 d-flex flex-nowrap align-items-center pt-2">
          <AppIcon defaultColor id="itemDesc" className="mr-2" />
          <LocalizedMessage id={type.labelId} />
        </div>
        <div className="col-12 d-flex flex-nowrap align-items-center pt-2">
          <AppIcon defaultColor id={tag.icon} className="mr-2" />
          <LocalizedMessage id={tag.labelId} />
        </div>
        <div className="col-12 d-flex flex-nowrap align-items-center pt-2">
          <AppIcon color={level.color} id={level.icon} className="mr-2" />
          <LocalizedMessage id={level.labelId} />
        </div>
        <div className="col-12 d-flex flex-nowrap align-items-center pt-2">
          <AppIcon defaultColor id={origin.icon} className="mr-2" />
          <LocalizedMessage id={origin.labelId} />
        </div>
        {log.desc && (
          <div className="col-12 pt-2">
            <div className="box-divider m-0" />
          </div>
        )}
        <div className="col-12 pt-2 c-word-wrap-break-word">
          <em>{log.desc}</em>
        </div>
      </div>
    </div>
  );
};

LogInfo.propTypes = {
  log: deviceLogDataShape.isRequired,
};

module.exports = LogInfo;



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/logs/LogInfo.js